module.exports = __webpack_public_path__ + "static/media/GothamBlack.89aec2cc.otf";